"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var judge = exports.judge = function judge(lat, lon, radius) {
  var polygons = window.fstAreas;
  if (polygons === false) return false;
  var circle = {
    radius: radius,
    center: [lat, lon]
  };
  if (Array.isArray(polygons) && polygons.length) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = polygons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var polygon = _step.value;

        var inPolygon = isPointInPolygon({ x: lon, y: lat }, polygon);
        if (inPolygon) return true;
        var bool = containPolygonByCircle(polygon, circle);
        if (bool) return true;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return false;
};

var isPointInPolygon = function isPointInPolygon(point, polygon) {
  var px = point.x,
      py = point.y,
      flag = false;
  for (var i = 0, l = polygon.length, j = l - 1; i < l; j = i, i++) {
    var p1 = polygon[i],
        p2 = polygon[j];
    var sx = p1[1],
        sy = p1[0],
        tx = p2[1],
        ty = p2[0];

    if (sx === px && sy === py || tx === px && ty === py) return true;

    if (sy < py && ty >= py || sy >= py && ty < py) {
      var x = sx + (py - sy) * (tx - sx) / (ty - sy);

      if (x === px) return true;
      if (x > px) flag = !flag;
    }
  }
  return flag;
};

var containPolygonByCircle = function containPolygonByCircle(polygon, circle) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = polygon[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var p = _step2.value;

      if (L.latLng(p).distanceTo(circle.center) <= circle.radius * 1000) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
};


//////////////////
// WEBPACK FOOTER
// ./js/business/judgeArea.js
// module id = 28
// module chunks = 0